var $name="shell/registry/PartialContext",$path="app/modules/shell/registry/PartialContext.js",$this={$name,$path,};import VisualContext from './Context';

export default class PartialContext extends VisualContext {}
